var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalkToAPeerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28901",
    "data-name": "Group 28901",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.774,
    height: 48.747,
    viewBox: "0 0 116.774 48.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4674",
    "data-name": "Rectangle 4674",
    width: 116.774,
    height: 48.747,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140260",
    "data-name": "Path 140260",
    d: "M24.374,0A24.374,24.374,0,1,0,37.7,44.78l11.051,1.206-2.6-10.654A24.371,24.371,0,0,0,24.374,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4670",
    "data-name": "Rectangle 4670",
    width: 29.29,
    height: 28.246,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28900",
    "data-name": "Group 28900",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28892",
    "data-name": "Group 28892",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28891",
    "data-name": "Group 28891",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140254",
    "data-name": "Path 140254",
    d: "M145.226,43.39l-.1,1.757.051.025c.789-1.5,1.68-1.935,3.844-1.935a4.659,4.659,0,0,1,3.361,1.044c.865.891,1.2,2.216,1.2,4.94,0,4.761-1.069,6.212-4.558,6.212-2.138,0-3.029-.459-3.666-1.884H145.3v6.823h-2.954V43.39Zm.1,5.856c0,3.157.509,3.9,2.7,3.9,2.164,0,2.622-.662,2.622-3.717,0-3.335-.408-3.946-2.674-3.946-2.189,0-2.647.662-2.647,3.768",
    transform: "translate(-74.642 -22.672)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140255",
    "data-name": "Path 140255",
    d: "M180.974,51.486c0,3.03-1.2,3.946-5.117,3.946-4.761,0-5.83-1.121-5.83-6.162,0-2.6.28-3.869,1.044-4.735.84-.916,2.165-1.3,4.558-1.3,3.106,0,4.43.687,5.041,2.571a12.761,12.761,0,0,1,.305,4.048h-8.045v.459c0,2.419.509,2.979,2.7,2.979,2.088,0,2.47-.28,2.5-1.808Zm-2.826-3.87c-.05-1.884-.432-2.24-2.571-2.24-1.553,0-2.113.2-2.419.942a4.789,4.789,0,0,0-.2,1.757h5.193Z",
    transform: "translate(-89.155 -22.672)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140256",
    "data-name": "Path 140256",
    d: "M208.114,51.486c0,3.03-1.2,3.946-5.117,3.946-4.761,0-5.83-1.121-5.83-6.162,0-2.6.28-3.869,1.044-4.735.84-.916,2.164-1.3,4.557-1.3,3.106,0,4.431.687,5.041,2.571a12.761,12.761,0,0,1,.305,4.048h-8.045v.459c0,2.419.51,2.979,2.7,2.979,2.088,0,2.47-.28,2.5-1.808Zm-2.826-3.87c-.051-1.884-.433-2.24-2.571-2.24-1.553,0-2.114.2-2.419.942a4.8,4.8,0,0,0-.2,1.757h5.194Z",
    transform: "translate(-103.387 -22.672)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140257",
    "data-name": "Path 140257",
    d: "M228.094,43.362l-.178,1.655.05.025a3.161,3.161,0,0,1,3.234-1.858,3.126,3.126,0,0,1,2.393.891c.56.637.738,1.4.738,3.03v.866h-2.7a5.484,5.484,0,0,0,.026-.662c0-1.451-.331-1.858-1.476-1.858a1.9,1.9,0,0,0-1.884,1.069,4.369,4.369,0,0,0-.2,1.731v7h-2.877V43.362Z",
    transform: "translate(-118.095 -22.644)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140258",
    "data-name": "Path 140258",
    d: "M46.143,35.333A24.387,24.387,0,1,0,37.7,44.78l11.051,1.207Z",
    transform: "translate(0 0)",
    fill: "#2da29a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28897",
    "data-name": "Group 28897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28896",
    "data-name": "Group 28896",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28895",
    "data-name": "Group 28895",
    transform: "translate(40.209 12.863)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28894",
    "data-name": "Group 28894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28893",
    "data-name": "Group 28893",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140259",
    "data-name": "Path 140259",
    d: "M99.7,27.043a14.125,14.125,0,0,0-13.062,19.5l-2.106,7.2,7.833-.5A14.124,14.124,0,1,0,99.7,27.043",
    transform: "translate(-84.537 -27.043)",
    fill: "#0f2531"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28899",
    "data-name": "Group 28899",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28898",
    "data-name": "Group 28898",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140261",
    "data-name": "Path 140261",
    d: "M92.054,44.074A11.545,11.545,0,1,0,103.6,32.529,11.545,11.545,0,0,0,92.054,44.074",
    transform: "translate(-48.27 -17.057)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140262",
    "data-name": "Path 140262",
    d: "M92.419,62.886l-2.16,7.384,7.138-.457Z",
    transform: "translate(-47.328 -32.975)",
    fill: "#0f2531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140263",
    "data-name": "Path 140263",
    d: "M12.945,40.318V37.67h2.877v2.648h4.532v2.164H15.822v5.957c0,1.375.229,1.706,1.222,1.706,1.12,0,1.4-.407,1.4-2.037a4.286,4.286,0,0,0-.025-.484h2.419v.688c0,1.654-.153,2.265-.637,2.928-.611.789-1.6,1.12-3.437,1.12-1.986,0-2.978-.433-3.513-1.476a3.906,3.906,0,0,1-.306-2.037V42.482",
    transform: "translate(-6.788 -19.753)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140264",
    "data-name": "Path 140264",
    d: "M33.182,46.506a3.666,3.666,0,0,1,.509-2.342c.636-.917,1.884-1.248,4.531-1.248,4.176,0,5.4.968,5.4,4.277v7.765H40.743l.127-1.63h-.076c-.636,1.375-1.5,1.782-3.768,1.782-3.183,0-4.328-.967-4.328-3.692,0-2.7,1.2-3.717,4.379-3.717,2.317,0,3.132.305,3.615,1.375h.051V47.143c0-1.884-.484-2.343-2.419-2.343-1.807,0-2.19.28-2.241,1.706Zm2.444,4.761c0,1.476.458,1.808,2.5,1.808s2.648-.408,2.648-1.731c0-1.349-.586-1.731-2.648-1.731-1.986,0-2.5.331-2.5,1.655",
    transform: "translate(-17.146 -22.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4671",
    "data-name": "Rectangle 4671",
    width: 2.877,
    height: 16.982,
    transform: "translate(29.251 15.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140265",
    "data-name": "Path 140265",
    d: "M76.312,42.232h.738l3.208-4.608h3.309l-4.15,5.6,4.99,6.289H80.87L77,44.243h-.687v5.27H73.435V32.531h2.877Z",
    transform: "translate(-38.507 -17.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4672",
    "data-name": "Rectangle 4672",
    width: 1.123,
    height: 1.234,
    transform: "translate(97.209 38.118)",
    fill: "#2da29a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140266",
    "data-name": "Path 140266",
    d: "M212.917,75.66v.162a1.979,1.979,0,0,1-.233,1.113c-.283.445-.729.587-1.8.587a2.529,2.529,0,0,1-1.74-.4c-.395-.344-.536-.86-.536-2.023a2.887,2.887,0,0,1,.365-1.821c.3-.415.86-.6,1.78-.6,1.64,0,2.095.374,2.095,1.73h-1.113c0-.677-.172-.83-.921-.83-.92,0-1.042.172-1.042,1.548,0,.769.071,1.153.253,1.336.121.121.374.172.82.172.819,0,.941-.131.941-.971Z",
    transform: "translate(-109.385 -38.108)",
    fill: "#2da29a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140267",
    "data-name": "Path 140267",
    d: "M223.111,73.07c.354.334.486.84.486,1.913,0,2.1-.385,2.539-2.226,2.539-1.113,0-1.649-.172-1.933-.637a3.555,3.555,0,0,1-.3-1.962c0-1.032.142-1.538.506-1.862.333-.293.759-.385,1.76-.385.962,0,1.4.1,1.71.395M220.3,75.053c0,1.386.131,1.578,1.053,1.578.951,0,1.082-.2,1.082-1.629,0-1.245-.142-1.437-1.073-1.437s-1.062.192-1.062,1.487",
    transform: "translate(-114.906 -38.108)",
    fill: "#2da29a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140268",
    "data-name": "Path 140268",
    d: "M231.657,72.736l-.03.728h.02a1.34,1.34,0,0,1,1.436-.789c.85,0,1.336.3,1.426.88h.02a1.369,1.369,0,0,1,1.5-.88,1.569,1.569,0,0,1,1.406.577,2.077,2.077,0,0,1,.213,1.083v3.126H236.5V74.577a1.827,1.827,0,0,0-.1-.678c-.091-.192-.324-.293-.7-.293a1.025,1.025,0,0,0-.962.405,1.606,1.606,0,0,0-.1.688v2.762H233.5V74.537a1.723,1.723,0,0,0-.081-.647c-.091-.182-.344-.283-.708-.283-.749,0-1.052.314-1.052,1.113v2.742h-1.143V72.736Z",
    transform: "translate(-120.873 -38.108)",
    fill: "#2da29a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140269",
    "data-name": "Path 140269",
    d: "M101.969,51.02V49.968h1.143V51.02h1.8v.86h-1.8v2.367c0,.547.091.678.486.678.445,0,.557-.162.557-.81a1.64,1.64,0,0,0-.01-.193h.961V54.2a1.713,1.713,0,0,1-.253,1.163c-.243.314-.637.446-1.366.446-.789,0-1.183-.173-1.4-.587a1.55,1.55,0,0,1-.121-.809V51.881",
    transform: "translate(-53.469 -26.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140270",
    "data-name": "Path 140270",
    d: "M113.735,52.447c.354.334.486.84.486,1.913,0,2.1-.384,2.539-2.226,2.539-1.113,0-1.649-.172-1.933-.637a3.555,3.555,0,0,1-.3-1.962c0-1.032.142-1.538.506-1.862.333-.293.759-.385,1.76-.385.961,0,1.4.1,1.71.395m-2.812,1.983c0,1.386.131,1.578,1.052,1.578.951,0,1.083-.2,1.083-1.629,0-1.245-.142-1.437-1.073-1.437s-1.062.192-1.062,1.487",
    transform: "translate(-57.553 -27.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140271",
    "data-name": "Path 140271",
    d: "M122.633,53.478a1.458,1.458,0,0,1,.2-.931c.253-.364.749-.5,1.8-.5,1.66,0,2.145.385,2.145,1.7v3.085h-1.143l.051-.647h-.031c-.253.546-.6.708-1.5.708-1.265,0-1.72-.385-1.72-1.467s.476-1.477,1.74-1.477c.92,0,1.244.122,1.436.547h.02v-.769c0-.749-.192-.931-.961-.931-.719,0-.87.111-.89.678Zm.971,1.892c0,.586.182.718.991.718s1.053-.162,1.053-.688-.233-.688-1.053-.688c-.789,0-.991.132-.991.658",
    transform: "translate(-64.203 -27.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140272",
    "data-name": "Path 140272",
    d: "M102.236,69.738A23.282,23.282,0,0,1,114.889,68.6c.748.143,1.068-1,.316-1.146a24.436,24.436,0,0,0-13.285,1.136c-.708.27-.4,1.42.316,1.147",
    transform: "translate(-53.233 -35.139)",
    fill: "#2da29a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToAPeerLogo);
export default __webpack_public_path__ + "static/media/talk-to-a-peer-logo.c7fbe20595e9609b89f72e2cef4e910d.svg";
export { ForwardRef as ReactComponent };